export enum MenuOptions {
    Home = 'Accueil',
    PrivateEvents = 'Evénements privés',
    PublicEvents = 'Evénements publics',
    PaymentForms = 'Formules',
    ContactForm = 'Demander un devis'
}